import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DynamoDBData from './DynamoDBData';
import HashSearch from './HashSearch';
import { loadConfig } from './config';
import { Box, CircularProgress } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, useTheme } from './utils/ThemeContext';
import getTheme from './utils/theme';

// Main component that decides what to render based on URL query parameters
function MainComponent() {
  const queryParams = new URLSearchParams(window.location.search);
  const hashParam = queryParams.get('hash');
  
  // If hash parameter exists, show HashSearch, otherwise show DynamoDBData
  return (
    <>
      {hashParam ? <HashSearch /> : <DynamoDBData />}
    </>
  );
}

// Wrapper for MUI Theme
function ThemedApp({ children }) {
  const { darkMode } = useTheme();
  return (
    <MuiThemeProvider theme={getTheme(darkMode ? 'dark' : 'light')}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}

function App() {
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    const init = async () => {
      await loadConfig();
      setConfigLoaded(true);
    };
    init();
  }, []);

  const appContent = !configLoaded ? (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      minHeight="100vh"
      sx={{ backgroundColor: 'var(--bg-primary)' }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <Router>
      <Routes>
        {/* Single route to handle both base view and hash search */}
        <Route path="/" element={<MainComponent />} />
        {/* Catch-all route for any other paths to redirect to home */}
        <Route path="*" element={<MainComponent />} />
      </Routes>
    </Router>
  );

  return (
    <ThemeProvider>
      <ThemedApp>
        {appContent}
      </ThemedApp>
    </ThemeProvider>
  );
}

export default App;

